import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getAllergyRows } from "./allergy-rows";

export const metadata = {
  tableType: "AllergyIntolerance",
  displayName: "Allergies",
  getRows: (bundle: FhirBundleSdk) => getAllergyRows({ bundle }),
};
